import React from 'react'

import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import DateDisplay from 'src/components/DateDisplay'
import { CandidateInterviewById } from 'src/queries'

interface ListProps {
  candidate: CandidateInterviewById | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { candidate } = props
  const section1: Array<Omit<ItemProps, 'id'>> = [
    {
      title: 'Round 1',
      value: <DateDisplay id='candidateRound1' date={candidate?.round_1} />
    },
    {
      title: 'Round 2',
      value: <DateDisplay id='candidateRound2' date={candidate?.round_2} />
    },
    {
      title: 'Round 3',
      value: <DateDisplay id='candidateRound3' date={candidate?.round_3} />
    }
  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: candidate === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <DescriptionList {...dlProps}>
      {section1.map(item => {
        const key = item.title.toLowerCase().replace(' ', '-')
        return <Item {...item} key={key} id={key} />
      })}
    </DescriptionList>
  )
}

export default List
